import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  HostListener,
  ViewChildren,
  QueryList
} from '@angular/core';
import { ApplyForPermitData } from './apply-for-permit.component.type';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { WorkflowContextService, WorkflowService } from 'src/app/services';
import { finalize } from 'rxjs/operators';
import { DataService } from 'src/app/services';
import { Client, Department, WorkflowType } from 'src/app/models';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';
import { svgs } from 'src/assets/export.assets';
import { combineLatest, Subject } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-apply-for-permit',
  standalone: false,
  templateUrl: './apply-for-permit.component.html',
  styleUrls: ['./apply-for-permit.component.css']
})
export class ApplyForPermitComponent {
  // selectedDepartmentIndex = 0;
  showBackward = false;
  showForward = false;
  useNewLayout: boolean;
  underlineLeft = 0;
  underlineWidth = 0;
  scrollTimeout: any;
  resizeTimeout: any;
  isLoading = false;
  // added by ketan 13-01-2026
  // -------------------------
  clientId = '';
  // -------------------------
  // ended by ketan 13-01-2026
  // loading=true
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private workflowService: WorkflowService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    public context: WorkflowContextService
  ) {
    this.useNewLayout = context.useNewLayout;
  }
  @ViewChild('deptContainer') deptContainer!: ElementRef<HTMLElement>;

  @ViewChildren(MatTooltip) tooltips!: QueryList<MatTooltip>;
  private resizeHandler = (): void => {
  this.onWindowResize();
};

  onWindowResize(): void {
// Added by Priya on 17-09-2026
// Handle mobile route-body styles when navigating from Apply for Permit to App View.

  const isAppViewRoute =
    this.router.url.includes(
      `/${applicantHomeRoutesNames.applyForPermit.route}/department/`
    ) &&
    (
      this.router.url.includes(
        `/${applicantHomeRoutesNames.application.route}/`
      ) ||
      this.router.url.includes(
        `/${applicantHomeRoutesNames.childApplication.route}/`
      )
    );
      const isDepartmentRoute =
    this.router.url.includes(
      `/${applicantHomeRoutesNames.applyForPermit.route}/department/`
    ) &&
    !this.router.url.includes(
      `/${applicantHomeRoutesNames.application.route}/`
    ) &&
    !this.router.url.includes(
      `/${applicantHomeRoutesNames.childApplication.route}/`
    );

if (isDepartmentRoute) {
  const scrollEl = document.querySelector('.route-body') as HTMLElement;

  if (scrollEl) {
    if (window.innerWidth >= 768) {
      scrollEl.style.setProperty('padding', '0px', 'important');
    }
  }

  
}

  if (isAppViewRoute) {
    if (window.innerWidth <= 767) {
      this.setMobileRouteBodyStyle();
    } else {      

      this.removeMobileRouteBodyStyle();
    }
  }
}
  ngAfterViewInit() {
     window.addEventListener('resize', this.resizeHandler);

    setTimeout(() => {
      this.onWindowResize();
    }, 300);  
    const el = document.querySelector('.route-body') as HTMLElement;
    if (el) {
el.style.setProperty('padding', '0px', 'important');    }

    setTimeout(() => {
      if (this.applyForPermitData.loading) return;
      this.updateArrowVisibility();
      this.onDepartmentScroll();

      this.cdr.detectChanges();
    }, 200);

  }

  ngOnDestroy() {
  window.removeEventListener('resize', this.resizeHandler);
      const el = document.querySelector('.route-body') as HTMLElement;
    if (el) {
      el.style.padding = '35px';
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  updateArrowVisibility() {
    const container = this.deptContainer?.nativeElement;
    if (!container) return;

    const deptCount = this.applyForPermitData.departmentData.length;
    if (deptCount <= 1) {
      this.showBackward = false;
      this.showForward = false;
      return;
    }

    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    const tolerance = 2;

    this.showBackward = container.scrollLeft > tolerance;
    this.showForward = container.scrollLeft < maxScrollLeft - tolerance;
  }

  @HostListener('window:resize')
  onResize() {
    this.checkDevice();
    this.updateArrowVisibility();
  }
  private checkMultiLineDepartments() {
    setTimeout(() => {
      const departments: any = document.querySelectorAll('.department');
      let hasWrappedText = false;

      departments.forEach((dept: any) => {
        const text = dept.querySelector('.dept-label');
        if (text && text.scrollHeight > 20) {
          hasWrappedText = true;
        }
      });

      departments.forEach((dept: any) => {
        dept.classList.toggle('multi-line', hasWrappedText);
      });
    });
  }
  onDepartmentScroll() {
    this.hideAllTooltips();
    const container = this.deptContainer?.nativeElement;
    if (!container) return;

    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    if (maxScrollLeft <= 1) {
      container.classList.remove('mask-start', 'mask-middle', 'mask-end');
      return;
    }

    this.updateArrowVisibility();

    container.classList.remove('mask-start', 'mask-middle', 'mask-end');

    const left = container.scrollLeft;
    const rightEdge = maxScrollLeft;

    const tolerance = 2;

    const atStart = left <= tolerance;
    const atEnd = left >= rightEdge - tolerance;

    if (atStart) {
      container.classList.add('mask-start');
    } else if (atEnd) {
      container.classList.add('mask-end');
    } else {
      container.classList.add('mask-middle');
    }
  }

  scrollDepartments(direction: 'left' | 'right') {
    const departments = this.applyForPermitData.departmentData;

    if (!departments || !departments.length) return;

    const newIndex =
      direction === 'right'
        ? Math.min(
          this.selectedDepartmentIndexDesktop + 1,
          departments.length - 1
        )
        : Math.max(this.selectedDepartmentIndexDesktop - 1, 0);

    if (newIndex === this.selectedDepartmentIndexDesktop) return;

    this.selectedDepartmentIndexDesktop = newIndex;

    this.scrollToDepartment(newIndex);

    const selectedDept = departments[newIndex];
    this.router.navigate([
      '/jurisdiction',
      this.clientId,
      applicantHomeRoutesNames.root,
      applicantHomeRoutesNames.applyForPermit.route,
      'department',
      selectedDept.departmentId
    ]);
    this.loadDepartmentWorkflows(selectedDept.departmentId);
  }

  selectedDepartmentIndexDesktop = 0;
  selectedDepartmentIndexMobile = 0;
  onDepartmentSelect(i: number) {
    this.selectedDepartmentIndexDesktop = i;

    const dept = this.applyForPermitData.departmentData[i];
    if (dept) {
      this.router.navigate([
        '/jurisdiction',
        this.clientId,
        applicantHomeRoutesNames.root,
        applicantHomeRoutesNames.applyForPermit.route,
        'department',
        dept.departmentId
      ]);
    }

    this.loadDepartmentWorkflows(dept.departmentId);

    this.scrollToDepartment(i);
  }
  scrollIntoView(index: number) {
    const container = this.deptContainer.nativeElement;
    const items = container.querySelectorAll<HTMLElement>('.department');
    const el = items[index];

    if (!el) return;

    const safeOffset = 40;
    const left = el.offsetLeft - container.clientWidth / 2 + el.offsetWidth / 2;

    container.scrollTo({
      left: left - safeOffset,
      behavior: 'smooth'
    });
  }

  onDepartmentOpen(index: number, dept: any) {
    this.router.navigate([
      '/jurisdiction',
      this.clientId,
      applicantHomeRoutesNames.root,
      applicantHomeRoutesNames.applyForPermit.route,
      'department',
      dept.departmentId
    ]);

    Promise.resolve().then(() => {
      dept.errorMsgOfPermitLinks = '';
      dept.departmentWorkflows = [];
      dept.loadingPermitLinks = true;
      this.selectedDepartmentIndexMobile = index;
      this.applyForPermitData.errorMsgOfPermitLinks = '';
    });

    const client = new Client({ id: this.clientId });

    this.workflowService
      .getPublishedWorkflows(
        client,
        [
          WorkflowType.Permit,
          WorkflowType.Other,
          WorkflowType.Renewable
        ],
        dept.departmentId,
        true
      )
      .subscribe({
        next: (res: any[]) => {
          if (!res || res.length === 0) {
            dept.loadingPermitLinks = false;
            dept.errorMsgOfPermitLinks =
              "This department currently doesn't have any workflows available for applying permits.";
            return;
          }

          dept.departmentWorkflows = res.map(wf => ({
            id: wf.id,
            applicationPermitName: wf.version.name
          }));

          dept.errorMsgOfPermitLinks = '';
          dept.loadingPermitLinks = false;
        },

        error: () => {
          dept.loadingPermitLinks = false;
          dept.errorMsgOfPermitLinks =
            'Something went wrong while fetching permits';
        }
      });
  }

  loadDepartmentWorkflows(deptId: string) {
    this.applyForPermitData.loadingPermitLinks = true;

    const dept = this.applyForPermitData.departmentData.find(
      d => d.departmentId === deptId
    );
    if (!dept) return;

    const client = new Client({ id: this.clientId });

    this.workflowService
      .getPublishedWorkflows(
        client,
        [
          WorkflowType.Permit,
          WorkflowType.Other,
          WorkflowType.Renewable
        ],
        deptId,
        true
      )
      .subscribe({
        next: (res: any[]) => {
          // ✅ No workflows case
          if (!res || res.length === 0) {
            this.applyForPermitData.errorMsgOfPermitLinks =
              "This department currently doesn't have any workflows available for applying permits.";

            dept.departmentWorkflows = [];
            this.applyForPermitData.loadingPermitLinks = false;
            return;
          }

          // ✅ Success
          dept.departmentWorkflows = res.map(wf => ({
            id: wf.version.workflowId,
            applicationPermitName: wf.version.name
          }));

          this.applyForPermitData.errorMsgOfPermitLinks = '';
          this.applyForPermitData.loadingPermitLinks = false;
        },

        error: () => {
          this.applyForPermitData.loadingPermitLinks = false;
          this.applyForPermitData.errorMsgOfPermitLinks =
            'Something went wrong while fetching permits';
        }
      });
  }

  showOverlay = false;
  startPermitWorkflow(index: number) {
    this.showOverlay = true;

    this.isLoading = true;

    const dept = this.applyForPermitData.departmentData[
      this.selectedDepartmentIndexDesktop ?? this.selectedDepartmentIndexMobile
    ];
    if (!dept.departmentWorkflows || !dept.departmentWorkflows[index]) {
      console.error('Workflow not found for this permit.');
      return;
    }

    const workflowId = dept.departmentWorkflows[index].id;
    this.dataService
      .startWorkflowApplication(workflowId)
      .pipe(finalize(() => (this.isLoading = false)))

      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          const isTestApplication = false;
          const startingActivityId = '1';
          this.workflowService.startApplication(
            workflowId,
            isTestApplication,
            startingActivityId
          );

          const applicationId =
            res?.applicationId ?? res?.applicationID ?? res?.applicationld;

          if (!applicationId) {
            console.error('❌ No applicationId found in response');
            // this.enableParentScroll();

            return;
          }
          // Navigate to the route that loads your AppViewComponent
          this.router.navigate(
            [
              'jurisdiction',
              this.clientId,
              'applicant-home',
              'apply-for-permit',
              'department',
              dept.departmentId,
              applicantHomeRoutesNames.application.route,
              applicationId
            ],
            {
              state: {
                startingActivityId,
                useNewLayout: this.useNewLayout,
                activeDrawerIndex: 0
              }
            }
          ).then(() => {
            // Added by Priya on 17-09-2026
            // Handle mobile route-body styling when directly navigating from Apply for Permit to App View.
            if (window.innerWidth <= 767 && (
              this.router.url.includes(`/${applicantHomeRoutesNames.applyForPermit.route}/department/`) &&
              (
                this.router.url.includes(`/${applicantHomeRoutesNames.application.route}/`) ||
                this.router.url.includes(`/${applicantHomeRoutesNames.childApplication.route}/`)
              )
            )) {
              setTimeout(() => {
                this.setMobileRouteBodyStyle();
              });
            }

          })
.catch((err) => {
});        }
      })
  }
  private setMobileRouteBodyStyle(): void {
    if (window.innerWidth <= 767) {
      const scrollEl = document.querySelector('.route-body') as HTMLElement;
      const mainBody = document.querySelector(
        '.main-body-container'
      ) as HTMLElement;

      if (scrollEl) {
        scrollEl.style.maxWidth = 'none';

      }

      if (mainBody) {
                mainBody.style.maxHeight = 'calc(100dvh - 220px)'

        mainBody.style.display = 'block';


      }
    }
  }
 
private removeMobileRouteBodyStyle(): void {
  const scrollEl = document.querySelector('.route-body') as HTMLElement;
  const mainBody = document.querySelector(
    '.main-body-container'
  ) as HTMLElement;

  if (scrollEl) {
    scrollEl.style.maxWidth = '1700px';
  }

  if (mainBody) {
    mainBody.style.maxHeight = '100%';
    mainBody.style.display = 'flex';
  }
}

  /** ✅ Center selected department */
  scrollToDepartment(index: number) {
    const container = this.deptContainer.nativeElement;
    const items = container.querySelectorAll<HTMLElement>('.department');
    const el = items[index];

    if (!el) return;

    el.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }
  private hideAllTooltips(): void {
    this.tooltips?.forEach(t => t.hide(0));
  }
  navigateToDepartment(index: number) {
    const dept = this.applyForPermitData.departmentData[index];
    if (dept?.departmentId) {
      this.router.navigate([
        '/jurisdiction',
        this.clientId,
        applicantHomeRoutesNames.root,
        applicantHomeRoutesNames.applyForPermit.route,
        'department',
        dept.departmentId
      ]);
    } else {
      console.error('Department name missing!');
    }
  }

  isPermitFormRoute = false;
  skeletonArray = Array(12).fill(0);
  skeletonBlocks = Array(5);
  isMobileDevice = false;
  checkDevice() {
    this.isMobileDevice = window.innerWidth < 600;
  }
  initialLoadDone = false;
  loadDepartments(deptIdFromUrl: string | null) {
    this.applyForPermitData.loading = true;
    this.applyForPermitData.errorMsg = '';
    this.applyForPermitData.departmentData = [];
    this.applyForPermitData.errorMsgOfPermitLinks = '';

    this.dataService
      .getClientDepartments(this.clientId, undefined, true)
      .subscribe({
        next: (departments: Department[]) => {
          setTimeout(() => {
            this.checkMultiLineDepartments();
          });
          this.selectedDepartmentIndexDesktop = 0;
          this.selectedDepartmentIndexMobile = 0;
          this.applyForPermitData.departmentData = [];

          if (!departments?.length) {
            this.applyForPermitData.errorMsg =
              'This jurisdiction does not have any departments';

            this.applyForPermitData.loading = false;
            return;
          }

          this.applyForPermitData.departmentData = departments.map(
            department => ({
              header: department.headerText,
              departmentSvg: department.iconUrl,
              departmentId: department.id,
              route: department.name.toLowerCase(),
              departmentName: department.name,
              departmentContent: [department.description],
              departmentHeader: `${department.name} Department Applications`,
              departmentWorkflows: [],
              loadingPermitLinks: false,
              errorMsgOfPermitLinks: ''
            })
          );

          this.applyForPermitData.loading = false;

          const targetDept =
            this.applyForPermitData.departmentData.find(
              d => d.departmentId === deptIdFromUrl
            ) ?? this.applyForPermitData.departmentData[0];

          const index = this.applyForPermitData.departmentData.indexOf(
            targetDept
          );

          this.selectedDepartmentIndexDesktop = index;
          this.selectedDepartmentIndexMobile = index;
          if (!this.isMobileDevice) {
            this.loadDepartmentWorkflows(targetDept.departmentId);
          }

          setTimeout(() => {
            const container = this.deptContainer?.nativeElement;

            if (container) {
              this.scrollToDepartment(index);
              this.updateArrowVisibility();
            }
          });

          if (!deptIdFromUrl && !this.initialLoadDone) {
            this.initialLoadDone = true;

            this.router.navigate(
              [
                '/jurisdiction',
                this.clientId,
                applicantHomeRoutesNames.root,
                applicantHomeRoutesNames.applyForPermit.route,
                'department',
                targetDept.departmentId
              ],
              { replaceUrl: true }
            );
            return
          }

        },

        error: () => {
          this.applyForPermitData.loading = false;

          this.applyForPermitData.errorMsg =
            'Something went wrong while fetching departments.';
        }
      });
  }
  private previousClientId: string | null = null;

  private destroy$ = new Subject<void>();
  ngOnInit() {
    this.checkDevice();

    combineLatest([
      this.route.paramMap,
      this.route.parent.parent.paramMap
    ])
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((prev, curr) => {
          const prevDept = prev[0].get('departmentId');
          const prevClient = prev[1].get('clientId');

          const currDept = curr[0].get('departmentId');
          const currClient = curr[1].get('clientId');

          return prevDept === currDept && prevClient === currClient;
        })
      )
      .subscribe(([params, parentParams]) => {
        const clientId = parentParams.get('clientId');
        const deptIdFromUrl = params.get('departmentId');
const isAppViewRoute =
  this.router.url.includes('/application/') ||
  this.router.url.includes('/child-application/');

if (!isAppViewRoute) {
  this.removeMobileRouteBodyStyle();
}
        if (this.router.url.includes('/application/')) {
          return;
        }

        if (this.previousClientId !== clientId) {
          this.previousClientId = clientId;
          this.clientId = clientId;

          this.loadDepartments(deptIdFromUrl);
          return;
        }

        if (deptIdFromUrl) {
          const index = this.applyForPermitData.departmentData.findIndex(
            d => d.departmentId === deptIdFromUrl
          );

          if (index !== -1) {
            this.selectedDepartmentIndexDesktop = index;
            this.selectedDepartmentIndexMobile = index;

            if (!this.isMobileDevice) {
              this.loadDepartmentWorkflows(deptIdFromUrl);
            }

            setTimeout(() => {
              this.scrollToDepartment(index);
            });
          }
        }
      });
  }


  moveForwardIcon = 'assets/images/move-forward.svg';
  moveBackwardIcon = 'assets/images/move-backward.svg';
  formDescriptionIcon = svgs.descriptionIcon.name;
  applyForPermitData: ApplyForPermitData = {
    headerData: '',
    departmentData: [],
    errorMsg: '',
    errorMsgOfPermitLinks: '',
    loading: false,
    loadingPermitLinks: false
  };
}
